<template>
  <div class="big">
    <div class="page_title">商品分类列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <el-button
          type="primary"
          @click="showFirst"
          :disabled="module_id_array[0]?!module_id_array.includes('342'):false"
        >添加一级分类</el-button>
        <div>
          <el-table
            :data="tableData"
            style="width:821px;margin-top: 20px;"
            row-key="category_id"
            border
            default-expand-all
            :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="sort"
              label="排序"
              width="240"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.sort"
                  style="width:160px"
                  @change="value=>{return changeSort(value,scope.row.category_id)}"
                  :disabled="module_id_array[0]?!module_id_array.includes('341'):false"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="category_name"
              label="分类名称"
              width="240"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="340"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="addCategory(scope.row)"
                  v-if="scope.row.level==1"
                  :disabled="module_id_array[0]?!module_id_array.includes('343'):false"
                >添加二级分类</el-button>
                <el-button
                  type="text"
                  @click="editCategory(scope.row)"
                  :disabled="module_id_array[0]?!module_id_array.includes('344'):false"
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="delCategory(scope.row.category_id)"
                  :disabled="module_id_array[0]?!module_id_array.includes('345'):false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <FirstChild
      v-if="firstShow"
      @close="firstShow=false"
      :oldInfo="currentInfo"
    ></FirstChild>
    <SecondChild
      v-if="secondShow"
      @close="secondShow=false"
      :oldInfo="currentInfo"
    ></SecondChild>
  </div>
</template>
<script>
import FirstChild from './FirstChild.vue';
import SecondChild from './SecondChild.vue';
export default {
  data() {
    return {
      tableData: [],
      firstShow: false,
      secondShow: false,
      currentInfo: {},
      category_pic: '',
      category_name: '',
      level2: false,
      imgbox: false,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0
    };
  },
  components: { FirstChild, SecondChild },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getList() {
      this.axios
        .post('platform/ManageGoods/getGoodsCategoryList')
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
          }
        });
    },

    //添加二级分类
    addCategory(item) {
      let info = {
        p_category_name: item.category_name,
        p_category_id: item.category_id
      };
      this.currentInfo = info;
      this.secondShow = true;
    },
    //编辑分类
    editCategory(item) {
      this.currentInfo = item;
      if (item.level == 2) {
        this.secondShow = true;
      } else {
        this.firstShow = true;
      }
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //删除
    delCategory(category_id) {
      this.$confirm('确定删除吗？', '提示信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            category_id
          };
          this.axios
            .post('platform/ManageGoods/deleteCategoryInfo', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    showFirst() {
      this.currentInfo = {};
      this.firstShow = true;
    },
    //提交保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          if (this.title == '添加分类') {
            this.axios
              .post('platform/goods/addGoodsCategory', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('添加成功');
                  this.add_category = false;
                  this.getList();
                }
              });
          } else {
            let data = this.ruleForm;
            this.axios
              .post('platform/goods/editGoodsCategory', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功');
                  this.add_category = false;
                  this.currentInfo = {};
                  this.getList();
                }
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //改变排序
    changeSort(value, category_id) {
      if (value) {
        let sort = value;
        this.axios
          .post('platform/ManageGoods/editGoodsSort', { category_id, sort })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('修改排序成功');
              this.getList();
            }
          });
      } else {
        this.getList();
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.big {
  text-align: left;
}
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
</style>

